/** Created by azhou on 2019/3/13.*/
<template>
  <div>
    <public-title>统计报表
      <div slot="right" class="ml-auto">
        <span class="text-link ml-2 h6" v-show="isGroup" @click="$router.back()">返回列表</span>
      </div>
    </public-title>
    <div class="load-area text-right">
      <el-date-picker class="w-30" v-model="timestamp" type="daterange" value-format="timestamp"
        size="small" start-placeholder="开始时间" end-placeholder="结束时间"/>
      <el-button class="ml-2" type="primary" size="small" @click="getChartLists">搜索</el-button>
      <div v-if="storeInfo.type!==2">
        <p class="mt-3 text-center" v-if="StoreChartLists.length<=0">当前没有数据</p>
        <div class="mt-3 text-center" v-else>
          <ul class="list-head">
            <li class="w-50" v-for="item in titleArr" :key="item">{{item}}</li>
          </ul>
          <ul class="list-item" v-for="item in StoreChartLists" :key="item.id">
            <li class="w-50 list-item-col">{{item.times}}</li>
            <li class="w-50 list-item-col" v-show="storeInfo.type===3">
              <span class="text-link" @click="getStatsDataList('push_nums','最近三个月匹配',item.times)">
                {{item.order_push_nums}}
              </span>
            </li>
            <li class="w-50 list-item-col" v-show="storeInfo.type===3">
              <span class="text-link" @click="getStatsDataList('offer_nums','报价次数',item.times)">
                {{item.order_offer_nums}}
              </span>
            </li>
            <li class="w-50 list-item-col">
              <span class="text-link" @click="getStatsDataList('success_order','成交订单数',item.times)">
                {{item.total_order_nos || 0}}
              </span>
            </li>
            <li class="w-50 list-item-col">{{item.total_price | formatMoney}}</li>
            <li class="w-50 list-item-col" v-show="!$GFUN.isInArray([5,8],storeInfo.type)">{{item.people_nums}}</li>
            <li class="w-50" :class="brand ? 'list-item-col' : 'list-item-col-end'">
              <span class="text-link" @click="getStatsDataList('income','实际收款金额',item.times)">
                {{item.total_pay_price/100 | formatMoney}}
              </span>
            </li>
          </ul>
        </div>
      </div>
      <travel-chart @changeDisplay="getChartLists" v-else/>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapActions, mapState, mapMutations} from 'vuex'
  import TravelChart from './TravelChart';

  export default {
    name: 'StoreChartLists',
    components: {TravelChart},
    computed: {
      ...mapState(['StoreChartLists']),
      ...mapGetters(['storeInfo', 'isGroup','brand']),
      queryCon() {
        return this.$route.query
      },
      titleArr() {
        switch (this.storeInfo.type) {
          case 3:
            return ['时间', '最近三个月匹配', '报价次数', '成交订单数', '成交订单金额', '接待人次', '实际收款金额'];
          case 5:
          case 8:
            return ['时间', '成交订单数', '成交订单金额', '实际收款金额'];
          case 6:
            return ['时间', '成交订单数', '成交订单金额', '接待人次', '实际收款金额'];
          default:
            return []
        }
      },
      //搜索条件-开始时间
      startTime() {
        return this.timestamp ? this.timestamp[0] / 1000 : '';
      },
      //搜索条件-结束时间
      endTime() {
        return this.timestamp ? this.timestamp[1] / 1000 + 86399 : '';
      },
    },
    watch: {
      queryCon() {
        this.getChartLists();
      },
      currentPage() {
        this.$router.push({name: this.$route.name, query: {...this.queryCon}})
      }
    },
    data() {
      return {
        timestamp: '',
      }
    },
    mounted() {
      this.UPDATECURRENTSTORE({storeId: this.queryCon.store});
      this.getChartLists();
    },
    beforeDestroy() {
      this.UPDATECURRENTSTORE({storeId: ''})
    },
    methods: {
      ...mapMutations(['UPDATECURRENTSTORE']),
      ...mapActions(['getStoreChartLists']),
      //获取统计报表信息
      getChartLists(val) {
        let data = {};
        switch (this.storeInfo.type) {
          case 2:
            let value = val || {};
            data = {
                start: this.startTime,
                end: this.endTime,
                pattern: value.mode,
                order_style: value.theme,
              };
            break;
          default:
            data = {
              start_time: this.startTime,
              end_time: this.endTime,
              is_merge: this.timestamp ? '1' : ''
            };
            break;
        }
        this.getStoreChartLists(data);
      },
      /*查看报表详情，获取某一月份的开始和结束时间戳,例如18-8，则获取18-8-1号和18-8-31号的时间戳*/
      getStatsDataList(type, cn, itemTime) {
        let startStamp, endStamp;
        if (this.timestamp) {
          startStamp = this.startTime;
          endStamp = this.endTime
        }
        else {
          let year = itemTime.split('-')[0], month = itemTime.split('-')[1];
          let firstDay = (new Date(year, month - 1, 1)).getTime() / 1000;
          let lastDay = (new Date(year, month, 0)).getTime() / 1000 + 86399;
          startStamp = firstDay;
          endStamp = lastDay;
        }
        this.$router.push({
          name: 'ChartDetail',
          query: {...this.queryCon, type, cn, startdate: startStamp, enddate: endStamp}
        });
      }
    },
  }
</script>
